import React from 'react';

const testimonials = [
  {
    name: 'Kim Breitwieser Lavin',
    rating: 5,
    text: 'Great place to bring the family! The staff is always friendly and helpful. Bowling lanes are well maintained and the food is delicious. We love coming here for birthday parties!',
    initials: 'KL',
  },
  {
    name: 'Amanda Leigh Rosa',
    rating: 4,
    text: 'Had an amazing time at Rock and Roll night! The glow bowling atmosphere was fantastic, and the music was great. Definitely recommend for a fun night out with friends.',
    initials: 'AR',
  },
  {
    name: 'Destinee Ramos',
    rating: 5,
    text: 'SkyLanes hosted our corporate event and it was a huge hit! Everything was perfectly organized. The team building activities were fun and the food was excellent. Will definitely book again!',
    initials: 'DR',
  },
];

function Testimonials() {
  return (
    <section className="testimonials section-padding" id="testimonials">
      <div className="container">
        <h5>Testimonials</h5>
        <h2>Our Customer Feedback</h2>
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div className="testimonial-card" key={index}>
              <div className="testimonial-stars">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span
                    key={star}
                    className={`star ${star <= testimonial.rating ? '' : 'empty'}`}
                  >
                    ★
                  </span>
                ))}
              </div>
              <div className="testimonial-body">
                <p>"{testimonial.text}"</p>
                <div className="testimonial-author">
                  <div className="testimonial-avatar">
                    {testimonial.initials}
                  </div>
                  <div>
                    <h4>{testimonial.name}</h4>
                    <span>Verified Customer</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
